// extracted by mini-css-extract-plugin
export default {"shopCategoryContainer":"shopCategory_shopCategoryContainer__rJ2+J","shopCategoryItemsContainer":"shopCategory_shopCategoryItemsContainer__86KeC","title":"shopCategory_title__vbJnI"};